/** CMS HOPE SIA question numbers (milestone vs symptom follow-up visit). */
export const milestoneQuestionNumber = 'J2051';
export const SFVQuestionNumber = 'J2053';

/** HOPE chip in the visit header; VisitPromptStack anchors to it. */
export const HOPE_VISIT_ICON_ID = 'hope-visit-icon';
